import React from 'react';


function Banner() {
    return (
        <div>
            <div className="mycontainer manage-workflow-box">
                <div className="row">
                    <div className="col-md-12 col-sm-12 col-xs-12">
                        <div className="createworkflowsection1">
                            <h4>Workflow Output</h4>
                            <p>You can view the list of workflows and there status here.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Banner